import React from 'react'
import Popup from '../components/Popup'
import Button from '../components/Button'
import { CashSalesAddToCartResponse } from '../CashSalesApi'

interface Props {
  onClose: () => void
  response: CashSalesAddToCartResponse
}

const CashSalesResultsPopup: React.FunctionComponent<Props> = ({ onClose, response }) => {
  const successful = response.results.filter(it => it.status)
  const failed = response.results.filter(it => !it.status)

  return (
    <Popup onClose={onClose}>
      <div className="title">
        {
          successful.length > 0
            ? 'Your list has been added to your Cash Sales cart.'
            : 'Your list was not added to your Cash Sales cart.'
        }

      </div>

      {
        successful.length > 0 && (
          <p>
            {successful.length} product{successful.length === 1 ? ' was' : 's were'} added.
          </p>
        )
      }
      {
        failed.length > 0 && (
          <p>
            {
              failed.length === 1
                ? 'This product couldn\'t be added:'
                : `These ${failed.length} products couldn't be added:`
            }
            <ul>
              {
                failed.map((cartItem, index) => (
                  <li key={index}>
                    <strong>{cartItem.itemNumber}</strong><br/>{cartItem.message}
                  </li>
                ))
              }
            </ul>
          </p>
        )
      }
      <div className="buttonRow">
        <Button
          onClick={onClose}
        >
          Okay
        </Button>
      </div>
    </Popup>
  )
}

export default CashSalesResultsPopup
